module.exports = __webpack_public_path__ + "img/thumbnail_WestAfricanLion_j_albino.e038e1c1.png";